
import Cross from '../Component/Cross';
import FourImg from '../Component/FourImg';

import Stack from '../Component/Stack';
import Whyus from '../Component/Whyus';
import LogoSlider from '../Component/LogoSlider';
// import Leaders from '../Component/Leaders';
import LatestInsights from '../Component/LatestInsights';
import Connect from '../Component/Connect';
import Home1 from '../Component/Home1';

const Home = () => {
  
  return (
    <>

      <Home1/>
      <br /><br /><br /><br /><br />
      <Cross />
      <FourImg />
      {/* <Counter/> */}
      <Stack />
      <Whyus />
      <LogoSlider />
      {/* <Leaders/> */}
      <LatestInsights />
      <Connect />

    </>
  )
}

export default Home
